module.exports = "<button class=\"btn btn-primary\" ng-click=\"$ctrl.openModal()\">\r\n    Zgłoś serwis wysyłkowy\r\n</button>"